var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.14 7.17C13.046 7.063 12.912 7.002 12.77 7H9V5.59C9 5.31 9.06 4.99 9.51 4.99H12.51C12.643 4.996 12.772 4.941 12.86 4.84C12.948 4.749 12.998 4.627 13 4.5V0.5C13 0.224 12.776 0 12.5 0H8.17C3.37 0 3 4.1 3 5.35V7H0.5C0.224 7 0 7.224 0 7.5V11.5C0 11.776 0.224 12 0.5 12H3V23.5C3 23.776 3.224 24 3.5 24H8.5C8.776 24 9 23.776 9 23.5V12H12.35C12.608 12.001 12.824 11.806 12.85 11.55L13.27 7.55C13.282 7.411 13.235 7.273 13.14 7.17Z",
    fill: "#CCE8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e846466dc0bc75b154c5668b50b31f03.svg";
export { ForwardRef as ReactComponent };